var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warning-modal-container" },
    [
      _c("BaseIcon", {
        staticClass: "modal-close-button flex-end",
        attrs: {
          icon: "close",
          isCustom: true,
          type: "standard",
          ariaLabel: "close modal dialog"
        },
        on: {
          click: function($event) {
            return _vm.$modal.hide("warningModal")
          }
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "message" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")
      ]),
      _vm._v(" "),
      _vm._l(_vm.buttons, function(button, index) {
        return _c(
          "div",
          { key: "warn-action-" + index, staticClass: "modal-action-wrapper" },
          [
            _c("BaseButton", {
              attrs: { title: button.title, type: "modal-button" },
              on: { click: button.action }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-065705da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-065705da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/WarningModal.vue
// module id = null
// module chunks = 